// import { allapiAction } from "@/Redux/common/action";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoaderComponent from "../Loader";
import OurWork from "../OurWork/OurWork";
import OurWork2 from "../OurWork/OurWork2";
import Category from "./Category";
import HomeSlider from "./HomeSlider";
import Listing from "./Listing";
import Listors from "./Listors";
import NavigateBtn from "./NavigateBtn";
import Product from "./Product";
import RecentProduct from "./RecentProduct";
import Video from "./Video";
import Winner from "./Winner";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import axios from "axios";
import Seo from "../Seo/Seo";
import FeProduct from "./FeProduct";
import Branch from "../OurWork/Branch";
import { Link } from "react-router-dom";
import TruncateText from "../TruncateText/TruncateText";
import CoustomImg from "../CoustomImg/CoustomImg";
import InfiniteScroll from "react-infinite-scroll-component";
import FeaturesSection from "./FeaturesSection";
import { Navbar } from "react-bootstrap";
import Slider from "../Slider"
import NotificationBar from "../NotificationBar"
import CategorySlider from "../CategorySlider"
import FeaturedProduct from "../FeaturedProduct"
import HomeBgBanner from "../HomeBgBanner"
import OurCourses from "../OurCourses";
import HomeBgBanner2 from "../HomeBgBanner2";
import AboutGold from "../AboutGold";
import Search3D from "../Search3D";
import BlogListpub2 from "../Blog/BlogListpub2";
import { FaBell } from "react-icons/fa";
import Trustedsection from "./Trustedsection";
import TeamSlider from "./TeamSlider";
import TestimonialsSlider from "./TestimonialsSlider";
import ContactHome from "./ContactHome";
import FaqSection from "./FaqSection";
import HeroSection from "./HeroSection";
import VideoCards from "../VideoCard";

function HomeComponent() {
  const dispatch = useDispatch();

  const get_marques_List = useSelector((state) =>
    state?.allapi?.get_marques_List ? state?.allapi?.get_marques_List : {}
  );

  const get_home_all_pro = useSelector((state) =>
    state?.allapi?.get_home_all_pro ? state?.allapi?.get_home_all_pro : {}
  );

  const news = get_marques_List?.news ? get_marques_List?.news : [];
  const admq = get_marques_List?.ads ? get_marques_List?.ads : [];
  const about = get_marques_List?.about ? get_marques_List?.about : [];

  useEffect(() => {
    dispatch(allapiAction.gethomePro({}));
    dispatch(allapiAction.getsliderList({ page: "home" }));
    dispatch(allapiAction.getMarqueesList2({ page: "home" }));
  }, []);

  const handleCreateOrder = async () => {
    try {
      const response = await axios.post(
        URL?.API_BASE_URL + "/publicApi/createOrdersq",
        {
          customerMobile: "9636996332",
          amount: "1",
          orderId: "testmrncxavfrrajm",
          redirectUrl: "http://localhost:6001",
          remark1: "test",
          remark2: "testsdt",
        }
      );

      if (response.data.status) {
        window.location.href = response.data.payment_url;
      } else {
        alert("Failed to create order");
      }
    } catch (error) {
      console.error("Error creating order:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 5000 &&
        !loading
      ) {
        setPage((prevPage) => prevPage + 1);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  const fetchProducts = async () => {
    try {
      await delay(500);
      const response = await fetch(
        `${URL.API_BASE_URL}/publicApi/gethomepageOnProduct?page=${page}`
      );
      const newProducts2 = await response.json();
      const newProducts = newProducts2?.data?.docs || [];
      // If no products are returned, set hasMore to false
      if (newProducts.length === 0) {
        setHasMore(false);
      }

      // Update products and increment page number
      setProducts((prevProducts) => [...prevProducts, ...newProducts]);
      setPage((prevPage) => prevPage + 1);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  const [windowWidth, setWindowWidth] = useState(600);

  // Update window width when the window is resized
  useLayoutEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
  <div className='notification-bar-new'>
            <div className="notification-wrapper my-3">
                <div className="notification-title d-flex align-items-center">
                    <FaBell />
                </div>
                <div className="notification-marquee">
                    <div className="notification-track">
     {about &&
                about?.map((data, i) => {
                  return <span key={data._id} className="notification-item">{data?.title}</span>;
                })}
                    </div>
                </div>
            </div>
        </div>
      {/* <NotificationBar /> */}
     < Slider />
    
      {/* <Slider /> */}
      {/* <Search3D /> */}
      {/* <CategorySlider /> */}
      {/* <FeaturedProduct /> */}

  <div className='notification-bar-new'>
            <div className="notification-wrapper my-3">
                <div className="notification-title d-flex align-items-center">
                    <FaBell />
                </div>
                <div className="notification-marquee">
                    <div className="notification-track">
     {about &&
                about?.map((data, i) => {
                  return <span key={data._id} className="notification-item">{data?.title}</span>;
                })}
                    </div>
                </div>
            </div>
        </div>
      <Seo
        settitle={"PSF ACADEMY"}
        titleSeo={"PSF ACADEMY"}
        seoKeyword={"PSF ACADEMY"}
        seo_descriptions={"PSF ACADEMY"}
        seoconcal={"https://psf.academy/"}
        title={"PSF ACADEMY"}
      />
      {Object.keys(get_home_all_pro)?.length > 0 ? (
        <div className="hometest">
          {/* <div className="marquee relative">
            <img
              src="/img/JOBPORTAL.png"
              alt="BeestBharatmessage.png"
              width={29}
              style={{
                position: "absolute",
                top: "0px",
                left: "0px",
                zIndex: "1",
              }}
            />
            <marquee behavior="scroll" direction="left" scrollamount="05">
              {about &&
                about?.map((data, i) => {
                  return <span key={data._id}>{data?.title}</span>;
                })}
            </marquee>
          </div> */}

          {/* <button
            onClick={() => {
              handleCreateOrder();
            }}
          >
            pay
          </button> */}
          {/* <OurWork2 homedata={get_home_all_pro} /> */}
          {/* <div className="marquee">
            <marquee behavior="scroll" direction="left" scrollamount="05">
              {about &&
                about?.map((data, i) => {
                  return <span key={data._id}>{data?.title}</span>;
                })}
            </marquee>
          </div> */}


          {/* <div className="">
            <HomeSlider />
          </div> */}
          {/* <Category homedata={get_home_all_pro} /> */}
 <Trustedsection />
          <AboutGold />
          <TeamSlider />
               <BlogListpub2 />
                 <VideoCards />
          <TestimonialsSlider />
         
          <ContactHome />
          <FaqSection />
          <HeroSection />
         
          {/* <FeaturesSection  /> */}
          {/* coment only for now */}
          {/* <div className="marquee mt-5">
            <marquee behavior="scroll" direction="left" scrollamount="05">
              {admq &&
                admq?.map((data, iy) => {
                  return <span key={data._id}>{data?.title}</span>;
                })}
            </marquee>
          </div> */}
          {/* <NavigateBtn homedata={get_home_all_pro} /> */}
          {/* <Product homedata={get_home_all_pro} /> */}

          {/* <Listing homedata={get_home_all_pro} /> */}
          {/* <OurWork />
          <FeProduct homedata={get_home_all_pro} />
          <HomeBgBanner />
          <OurCourses />
          <RecentProduct homedata={get_home_all_pro} />
          <HomeBgBanner2 /> */}
   
        
          {/* <Winner homedata={get_home_all_pro} /> */}
          {/* {news?.length > 0 && (
            <div className="  ">
              <div className="mark_bg mt-2">
                <div className="headertext">Latest Notification</div>
                <div className="news">
                  <marquee>
                    {news &&
                      news?.map((data, i) => {
                        return <span key={data._id}>{data?.title}</span>;
                      })}
                  </marquee>
                </div>
              </div>
            </div>
          )} */}

          <div className=" ">
            {/* <Video homedata={get_home_all_pro} /> */}

            {/* <Listors homedata={get_home_all_pro} /> */}

            {/* <OurWork homedata={get_home_all_pro} /> */}
            {/* <Branch homedata={get_home_all_pro} /> */}
          </div>

          {/* <div className="featured-product-slider-container px-1 mt-4 feature-product-new">
            <div className="featured-product-header position-relative overflow-hidden d-flex justify-content-between align-items-center p-2 mb-2">
              <div>
                <h5 className="fw-bold featured-product-text mb-0">ALL PRODUCTS</h5>
              </div>
              <div>
                <Link className="text-decoration-none fw-bold featured-product-text" to="/products">View all</Link>
              </div>
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
            </div>

            <div className="ps-section__content mt-3">
              <InfiniteScroll
                dataLength={products.length}
                next={fetchProducts}
                hasMore={hasMore}
                loader={<div className="spinnerContainer"><section className="dots-container"><div className="dot"></div><div className="dot"></div><div className="dot"></div><div className="dot"></div><div className="dot"></div></section></div>}
                endMessage={<p></p>}
              >
                <div className="container-fluid">
                  <div className="row">
                    {products.map((data, index) => (
                      <div className="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 mb-2" key={index}>
                        <Link to={data?.typeof === "Listing" ? "/listing/" + data?.pro_sulg : "/product/" + data?.pro_sulg} className="text-decoration-none">
                          <div className="featured-product-card tilt">
                            <div className="img-box">
                              <CoustomImg
                                url={URL.API_BASE_URL + data?.featureImage}
                                altkey={data?.title}
                                w1={200}
                                w2={250}
                                h1={160}
                                h2={220}
                              />
                            </div>
                            <span className="mannu-bhai"></span>
                            <span className="mannu-bhai"></span>
                            <span className="mannu-bhai"></span>
                            <span className="mannu-bhai"></span>
                            <div style={{ lineHeight: "0.6" }}>
                              <p><TruncateText text={data?.title} maxLength={windowWidth > 600 ? 25 : 15} /></p>
                              {data?.afterdiscountprice && (
                                <div className="d-flex align-items-center">
                                  <span className="fw-bold text-success">₹{data?.afterdiscountprice}/-</span>
                                  <span className="text-warning fw-bold text-decoration-line-through ms-3">₹{data?.price}/-</span>
                                </div>
                              )}
                              <p className="ps-product__vendor text-dark fw-bold">{data?.sellerId?.displayName}</p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </InfiniteScroll>
            </div>
          </div> */}

        </div>
      ) : (
        <LoaderComponent />
      )}
      <hr />
    </div>
  );
}

export default HomeComponent;
